import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { useTracking } from '../../../../../hooks/useTracking';
import type { NormalizedDecisionMaker } from '../../../../types';
import { useIsResponseTruncated } from '../useIsResponseTruncated';

type Result = ModelHookResult<
	{
		responseText: string | undefined | null;
		readMoreLink: string;
		responseRef: React.RefObject<HTMLElement | null>;
		isTruncated: boolean;
	},
	{ trackReadFullDMResponseClick: () => void }
>;

export function useDecisionMakerResponse(response: NormalizedDecisionMaker['response']): Result {
	const {
		data: { isTruncated, ref: responseRef },
	} = useIsResponseTruncated();

	const { trackReadFullDMResponseClick } = useTracking();

	const {
		data: {
			petition: { slug },
		},
	} = usePetitionDetailsPageData();

	const handleClick = () => {
		trackReadFullDMResponseClick(response?.id || '');
	};

	return {
		data: {
			responseText: response?.message,
			readMoreLink: `/p/${slug}/responses/${response?.id}`,
			isTruncated,
			responseRef,
		},
		actions: { trackReadFullDMResponseClick: handleClick },
	};
}
